/* Koforto 产品页行为汇总：只在产品页由 theme.liquid 按需加载。 */
(() => {
  'use strict';
  try {
    const tag = document.currentScript || document.querySelector('script[data-koforto-behavior]');
    const endpoint = tag && tag.dataset.endpoint;
    if (!endpoint || !/^https:\/\//i.test(endpoint)) return;

    const safeStorage = (() => {
      try { return window.sessionStorage; } catch (_) { return null; }
    })();
    const attributionKey = 'kf_behavior_attribution_v1';
    const readAttribution = () => {
      try {
        const saved = safeStorage && JSON.parse(safeStorage.getItem(attributionKey) || '{}');
        return {
          landing_path: typeof saved.landing_path === 'string' && saved.landing_path.charAt(0) === '/' ? saved.landing_path : location.pathname,
          attribution: saved && typeof saved.attribution === 'object' && !Array.isArray(saved.attribution) ? saved.attribution : {}
        };
      } catch (_) {
        return { landing_path: location.pathname, attribution: {} };
      }
    };

    const id = (() => {
      try { return crypto.randomUUID(); } catch (_) {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
          const n = Math.floor(Math.random() * 16);
          return (c === 'x' ? n : ((n & 3) | 8)).toString(16);
        });
      }
    })();
    const startedAt = new Date();
    let visibleSince = document.visibilityState === 'visible' ? Date.now() : 0;
    let engagedMs = 0;
    let maxScrollPct = 0;
    let lcpMs = null;
    let lastSentAt = 0;
    const sectionsSeen = new Set();
    const interactions = { variant_change: 0, image_swipe: 0, size_guide_open: 0 };

    const normalizeSection = (value) => {
      const label = String(value || '').trim().toLowerCase().replace(/[^a-z0-9-]+/g, '-').replace(/^-+|-+$/g, '');
      return /^[a-z0-9-]{1,64}$/.test(label) ? label : '';
    };
    const flushEngaged = () => {
      if (visibleSince) {
        engagedMs += Math.max(0, Date.now() - visibleSince);
        visibleSince = 0;
      }
    };
    const updateScroll = () => {
      const root = document.documentElement;
      const max = Math.max(root.scrollHeight, document.body ? document.body.scrollHeight : 0) - window.innerHeight;
      const raw = max > 0 ? (window.scrollY / max) * 100 : 0;
      const bucket = raw >= 100 ? 100 : raw >= 75 ? 75 : raw >= 50 ? 50 : raw >= 25 ? 25 : 0;
      maxScrollPct = Math.max(maxScrollPct, bucket);
    };
    const device = () => window.innerWidth < 750 ? 'mobile' : window.innerWidth < 990 ? 'tablet' : 'desktop';
    const cookie = (name) => {
      try {
        const match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/[.$?*|{}()[\]\\/+^]/g, '\\$&') + '=([^;]*)'));
        return match ? decodeURIComponent(match[1]) : '';
      } catch (_) { return ''; }
    };
    const payload = () => {
      flushEngaged();
      if (document.visibilityState === 'visible') visibleSince = Date.now();
      const saved = readAttribution();
      return {
        v: 1,
        page_id: id,
        client_id: cookie('_shopify_y'),
        host: location.hostname,
        path: location.pathname,
        landing_path: saved.landing_path,
        attribution: saved.attribution,
        device: device(),
        viewport_w: Math.max(1, Math.round(window.innerWidth || 1)),
        lcp_ms: lcpMs,
        engaged_ms: Math.min(86400000, Math.round(engagedMs)),
        max_scroll_pct: maxScrollPct,
        sections_seen: Array.from(sectionsSeen),
        interactions,
        started_at: startedAt.toISOString(),
        ended_at: new Date().toISOString()
      };
    };
    const send = () => {
      const now = Date.now();
      if (now - lastSentAt < 250) return;
      lastSentAt = now;
      try {
        const body = JSON.stringify(payload());
        const blob = new Blob([body], { type: 'text/plain;charset=UTF-8' });
        if (navigator.sendBeacon) navigator.sendBeacon(endpoint, blob);
      } catch (_) {}
    };

    updateScroll();
    window.addEventListener('scroll', updateScroll, { passive: true });
    window.addEventListener('resize', updateScroll, { passive: true });
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') {
        flushEngaged();
        send();
      } else {
        visibleSince = Date.now();
      }
    });
    window.addEventListener('pagehide', () => {
      flushEngaged();
      send();
    }, { capture: true });

    if ('PerformanceObserver' in window) {
      try {
        const observer = new PerformanceObserver((list) => {
          const entries = list.getEntries();
          const last = entries[entries.length - 1];
          if (last && Number.isFinite(last.startTime)) lcpMs = Math.min(120000, Math.round(last.startTime));
        });
        observer.observe({ type: 'largest-contentful-paint', buffered: true });
      } catch (_) {}
    }

    const seenTargets = Array.from(document.querySelectorAll('[data-track-section]'));
    if ('IntersectionObserver' in window) {
      try {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
              const label = normalizeSection(entry.target.getAttribute('data-track-section'));
              if (label) sectionsSeen.add(label);
              observer.unobserve(entry.target);
            }
          });
        }, { threshold: [0.5] });
        seenTargets.forEach((node) => observer.observe(node));
      } catch (_) {}
    } else {
      seenTargets.forEach((node) => {
        const label = normalizeSection(node.getAttribute('data-track-section'));
        if (label) sectionsSeen.add(label);
      });
    }

    document.addEventListener('change', (event) => {
      try {
        const target = event.target;
        if (target && target.matches('select,input') && target.closest('variant-radios, variant-selects, kf-picker, kf-bundle, .product-form__input, [data-variant-picker]')) {
          interactions.variant_change += 1;
        }
      } catch (_) {}
    }, { passive: true });
    document.addEventListener('kf:change', () => { interactions.variant_change += 1; }, { passive: true });

    let galleryStart = null;
    document.addEventListener('pointerdown', (event) => {
      try {
        if (event.target.closest('[data-gallery], .product__media-wrapper, .product-media-container')) galleryStart = { x: event.clientX, y: event.clientY };
      } catch (_) {}
    }, { passive: true });
    document.addEventListener('pointerup', (event) => {
      try {
        if (galleryStart && event.target.closest('[data-gallery], .product__media-wrapper, .product-media-container') && Math.abs(event.clientX - galleryStart.x) > 30) interactions.image_swipe += 1;
      } catch (_) {}
      galleryStart = null;
    }, { passive: true });
    document.addEventListener('click', (event) => {
      try {
        const clicked = event.target.closest('[data-gallery] button, .product__media-toggle, .thumbnail');
        if (clicked) interactions.image_swipe += 1;
        const sizeGuide = event.target.closest('[data-size-guide], [data-size-guide-open], [aria-controls*="size" i], button, a');
        if (sizeGuide && (/size\s*guide|größentabelle|guide\s+des\s+tailles/i.test(sizeGuide.textContent || '') || sizeGuide.matches('[data-size-guide], [data-size-guide-open], [aria-controls*="size" i]'))) {
          interactions.size_guide_open += 1;
        }
      } catch (_) {}
    }, { passive: true });
  } catch (_) {}
})();
